module.exports = __webpack_public_path__ + "static/media/zr_2_16.580ecd9d.png";